import React, { useContext, useEffect, useState } from "react";
import { Button } from "react-daisyui";
import { useSwipeable } from "react-swipeable";
import AppContext from "./hooks/createContext";
import Sparkle from "./Sparkle";
import { url } from "inspector";
import { useTranslation } from 'react-i18next';

interface MobileSegmentDrawerProps {
  handleResetInteraction: () => void;
  handleMagicErase: () => void;
  handleCreateSticker: () => void;
  userNegClickBool: [
    userNegClickBool: boolean,
    setUserNegClickBool: (e: boolean) => void
  ];
}

const MobileSegmentDrawer = ({
  handleResetInteraction,
  handleMagicErase,
  handleCreateSticker,
  userNegClickBool: [userNegClickBool, setUserNegClickBool],
}: MobileSegmentDrawerProps) => {
  const { t } = useTranslation();
  const {
    segmentTypes: [segmentTypes, setSegmentTypes],
    svg: [svg, setSVG],
    stickers: [stickers, setStickers],
    activeSticker: [activeSticker, setActiveSticker],
    isModelLoaded: [isModelLoaded, setIsModelLoaded],
    click: [click, setClick],
    clicks: [clicks, setClicks],
    stickerTabBool: [stickerTabBool, setStickerTabBool],
    allsvg: [allsvg, setAllsvg],
    didShowAMGAnimation: [didShowAMGAnimation, setDidShowAMGAnimation],
    showLoadingModal: [showLoadingModal, setShowLoadingModal],
  } = useContext(AppContext)!;
  const [everythingBool, setEverythingBool] = useState<Boolean>(false);
  const [hasTouchedErase, sethasTouchedErase] = useState<Boolean>(false);

  useEffect(() => {
    setEverythingBool(segmentTypes === "All");
  }, [segmentTypes]);

  useEffect(() => {
    setStickerTabBool(() => false);
  }, [click]);

  const superDefer = (cb: Function) => {
    setTimeout(
      () =>
        window.requestAnimationFrame(() => {
          setTimeout(() => {
            cb();
          }, 0);
        }),
      0
    );
  };

  const handleStickerClick = (i: number) => {
    setActiveSticker(i);
  };

  const handlers = useSwipeable({
    onSwipedUp: () => setStickerTabBool(true),
    onSwipedDown: () => setStickerTabBool(false),
    swipeDuration: 200,
    delta: 5,
    preventScrollOnSwipe: true,
  });

  return (
      <div {...handlers}>
        <div className="flex w-96 gap-4 mt-2 font-bold mx-auto">
          <button
            className={`font-bold shadow-[0px_0px_5px_5px_#00000024] flex flex-1 flex-row items-center px-6 py-2 text-lg justify-center ${userNegClickBool
                ? "text-gray-700 bg-gray-400"
                : "text-white bg-blue-700"
              } rounded-full w-max`}
            style={{
              background:userNegClickBool?`url("./static/assets/btn-bg-dark.png") 100% 100%`:`url("./static/assets/btn-bg-gold.png")`,
              backgroundSize:userNegClickBool?"100% 100%":"cover",
              color:userNegClickBool?"#d4b686":"#000"
            }}
            onClick={() => setUserNegClickBool(false)}
          >
            
            <span>{t('controls.select')}</span>
          </button>
          <button
            className={`font-bold shadow-[0px_0px_5px_5px_#00000024] flex flex-1 flex-row items-center px-6 py-2 text-lg justify-center rounded-full w-max ${
              userNegClickBool
                ? "text-white bg-blue-700"
                : "text-gray-700 bg-gray-400"
            } ${!clicks || clicks?.length === 0 ? "disabled" : ""}`}
            style={{
              background:userNegClickBool?`url("./static/assets/btn-bg-gold.png") 100% 100%`:`url("./static/assets/btn-bg-dark.png")`,
              backgroundSize:userNegClickBool?"100% 100%":"cover",
              color:userNegClickBool?"#000":"#d4b686"
            }}
            onClick={() => setUserNegClickBool(true)}
          >
            
            <span>{t('controls.exclude')}</span>
          </button>
        </div>
        
      </div>
  );
};

export default MobileSegmentDrawer;
